<template>
  <div class="serivce">
    <el-button @click="back" class="back-button">{{
      $t("B2C.back")
    }}</el-button>
    <div class="serivce-title">{{ $t("contactService.title") }}</div>
    <div class="serivce-container">
      <div class="page-action-box">
        <el-button type="primary" @click="addService">{{
          $t("contactService.createProblem")
        }}</el-button>
      </div>
      <el-table :data="contents" ref="table">
        <!-- <el-table-column  width="55"></el-table-column> -->
        <el-table-column
          :label="$t('contactService.col1')"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <p class="title">{{ scope.row.Title }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('contactService.col2')" align="center">
          <template slot-scope="scope">
            <p class="row-product-price">{{ scope.row.ServiceTypeName }}</p>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('contactService.col3')"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <p class="row-product-sales">{{ scope.row.SubmitTime }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('contactService.col4')" align="center">
          <template slot-scope="scope">
            <div class="row-product-create-time">
              <p :class="scope.row.Status == '0' ? 'pending' : 'finished'">
                {{ scope.row.StatusStr }}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('contactService.col5')"
          align="center"
          class-name="column-action"
        >
          <template slot-scope="scope">
            <div class="row-product-action">
              <p @click="checkDetail(scope.row.PFId)">
                {{ $t("contactService.view") }}
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        :current-page="page"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 联系客服弹窗 -->
    <el-dialog
      :title="$t('contactService.tips')"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      center
    >
      <h3 style="margin-top:0px">{{ $t("contactService.serviceContent") }}</h3>
      <el-select
        class="m-b-20"
        v-model="service.serviceType"
        :placeholder="$t('B2C.select')"
        style="width:100%"
      >
        <el-option
          v-for="item in serviceTypeList"
          :key="item.STId"
          :label="item.ServiceTypeName"
          :value="item.STId"
        ></el-option>
      </el-select>
      <el-input
        class="m-b-20"
        v-model="service.title"
        :placeholder="$t('contactService.inputTitle')"
      ></el-input>
      <el-input
        type="textarea"
        :placeholder="$t('contactService.inputContent')"
        :autosize="{ minRows: 4 }"
        v-model="service.serviceContent"
      ></el-input>
      <h3>{{ $t("contactService.contact") }}</h3>
      <el-input
        :placeholder="$t('contactService.inputEmail')"
        v-model="service.serviceEmail"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="serviceSubmit">{{
          $t("contactService.submit")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "VancheenContactservice",

  data() {
    return {
      page: 1,
      pageSize: 20,
      count: 0,
      lastPage: 0,
      contents: [],
      dialogVisible: false,
      serviceTypeList: [
        { value: "1", label: this.$t("contactService.option1") },
        { value: "2", label: this.$t("contactService.option2") },
        { value: "3", label: this.$t("contactService.option3") }
      ],
      service: {
        serviceType: "", //服务类型
        serviceContent: "", //服务内容
        serviceEmail: "", //邮箱地址
        title: "" //问题标题
      },
      platformType: "SU"
    };
  },

  computed: {
    ...mapState({
      supplierInfo: state => state.supplier.supplierInfo,
      cUserInfo: state => state.cUser.cUserInfo
    })
  },

  mounted() {
    const { Type } = this.$route.query;
    this.platformType = Type;
    this.getProblemFeedbackByPage();
  },

  methods: {
    back() {
      this.$router.back(-1);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getProblemFeedbackByPage();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getProblemFeedbackByPage();
    },
    // 添加服务
    addService() {
      this.dialogVisible = true;
      this.getServiceType();
    },
    // 获取服务类型
    getServiceType() {
      this.$api.system
        .getServiceTypeList()
        .then(res => {
          this.serviceTypeList = res.data;
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },
    // 添加服务请求
    addProblemFeedback() {
      let param = {
        UserId:
          this.platformType == "C"
            ? this.cUserInfo.UserId
            : this.supplierInfo.UserId,
        PlatformType: this.platformType,
        Title: this.service.title,
        STId: this.service.serviceType,
        Content: this.service.serviceContent,
        ContactWay: this.service.serviceEmail
      };
      this.$api.system
        .addProblemFeedback(param)
        .then(() => {
          this.dialogVisible = false;
          this.$message.success(this.$t("B2C.success"));
          this.initServiceObj();
          this.getProblemFeedbackByPage();
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },
    // 获取问题反馈列表
    getProblemFeedbackByPage() {
      let param = {
        UserId:
          this.platformType == "C"
            ? this.cUserInfo.UserId
            : this.supplierInfo.UserId,
        PlatformType: this.platformType,
        PageIndex: this.page,
        PageSize: this.pageSize
      };
      this.$api.system
        .getProblemFeedbackByPage(param)
        .then(res => {
          this.page = res.meta.page;
          this.count = res.meta.total;
          this.lastPage = res.meta.lastPage;
          this.contents = res.data;
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },
    // 弹窗关闭函数
    handleClose(done) {
      this.initServiceObj();
      done();
    },
    // 提交
    serviceSubmit() {
      if (
        this.service.serviceType == "" ||
        this.service.serviceContent == "" ||
        this.service.serviceEmail == "" ||
        this.service.title == ""
      ) {
        this.$message.error(this.$t("contactService.inputAll"));
        return false;
      } else {
        this.addProblemFeedback();
      }
    },
    // 初始化表单
    initServiceObj() {
      for (let i in this.service) {
        this.service[i] = "";
      }
    },
    checkDetail(id) {
      this.$router.push({
        path: "serviceDetail",
        query: { id: id, Type: this.platformType }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pending {
  color: #e7a645;
}
.finished {
  color: #67c23a;
}
.m-b-10 {
  margin-bottom: 10px;
}
.m-b-20 {
  margin-bottom: 20px;
}
.serivce {
  padding-bottom: 10%;
  background: rgb(246, 246, 246);
  .back-button {
    left: 3%;
    top: 3%;
    font-size: 14px;
    position: absolute;
    z-index: 11;
  }
  .serivce-title {
    width: 50%;
    font-size: 25px;
    margin: auto;
    text-align: center;
    padding: 30px;
    background: #fff;
    margin-bottom: 20px;
  }
  .serivce-container {
    width: 50%;
    min-height: 800px;
    margin: auto;
    padding: 30px;
    background: #fff;
    .page-action-box {
      margin-bottom: 2%;
    }
    .row-product-name {
      display: flex;

      .image {
        width: 66px;
        height: 66px;
        flex-shrink: 0;
      }

      .content {
        margin-left: 20px;
        font-size: 12px;
        flex: 1;
        position: relative;
        p {
          margin: 0;
        }
        .title {
          color: #333;
          width: 7rem;
        }
        .labelimg {
          position: absolute;
          top: 0;
          left: 8rem;
        }

        .id {
          margin-top: 10px;
          color: #999;
        }
      }
    }
    .row-product-price {
      margin: 0;
      font-size: 12px;
      // color: #ff5852;
    }
    .row-product-sales {
      @extend .row-product-price;
      color: #333;
    }

    .row-product-create-time {
      font-size: 12px;

      p {
        margin: 0;
      }

      .date {
        color: #333;
      }

      .state {
        margin-top: 2px;
        color: #22b196;
      }
    }
    .row-product-action p {
      font-size: 12px;
      color: #25b9ff;
      margin: 0;
      cursor: pointer;
    }
    .el-pagination {
      margin-top: 2%;
      margin-bottom: 2%;
      text-align: right;
    }
  }
}
</style>
